import { createSelector } from 'reselect'
import * as R from 'ramda'
import { GLOBAL_ROLES } from 'containers/Role/constants'

const globalRoleSelector = state => state.roles.global.roles
const isLoadedSelector = state => state.roles.global.isLoaded
const isClientSelector = createSelector(
  globalRoleSelector,
  R.contains(GLOBAL_ROLES.CLIENT_ACCESS)
)

export {
  globalRoleSelector,
  isLoadedSelector,
  isClientSelector,
}
